import React from "react";
import ReactHtmlParser from "react-html-parser";

import CrossIcon from "../../img/icons/Cross";

import "./popupFilledHeader.scss";

class PopupFilledHeader extends React.Component {
    render() {
        return (
            <div className='popup-filled-header'>
                {this.props.title !== undefined && <div>{ReactHtmlParser(this.props.title)}</div>}
                {this.props.logo !== undefined && this.renderLogo()}
                {typeof(this.props.close) === 'function' && <CrossIcon className='icon-centered' onClick={() => this.props.close()} />}
            </div>
        )
    }

    renderLogo = () => {
        const L = this.props.logo;
        return <L />
    }
}

export default PopupFilledHeader;